import { render, staticRenderFns } from "./course-escort.vue?vue&type=template&id=1da1a6b9&scoped=true&"
import script from "./course-escort.vue?vue&type=script&lang=js&"
export * from "./course-escort.vue?vue&type=script&lang=js&"
import style0 from "./course-escort.vue?vue&type=style&index=0&id=1da1a6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1a6b9",
  null
  
)

export default component.exports